module.exports = __webpack_public_path__ + "img/f30ae31.webp";